import {currencyField} from "../../../../services/validate"
import {BaSeGrid, BaSeGridItem, BaSeParagraph} from "@base/react"
import FormInput from "../../../../components/form-builder/form-input"
import FormBuilder from "../../../../components/form-builder/form-builder"
import * as Yup from "yup"
import AccordionModal from "../../../../components/accordion-modal"
import Button from "../../../../components/button/button"

const totalInvestmentValidation = Yup.object().shape({
  cgp: currencyField("Valor Capital de Giro próprio"),
  iif: currencyField("Valor investimento fixo"),
})

const TotalInvestment = ({ data, isDisabled, onChange, onSubmit, postCredit = false, lab = false }) => {
  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    } else {
      onChange(null, values);
    }
  };

  return (
    <div className="step total-investment">
      <div className="step--info">
        <h3 className="step--title">
          Identificação de custos associados às operações da empresa.
        </h3>
        <h5 className="step--subtitle">
          Os campos são opcionais, mas para garantir resultados mais precisos, preencha todas as informações disponíveis.
        </h5>
      </div>
      {!(postCredit || lab) && <AccordionModal title="Exemplos:">
        <div className="example">
          <div>
            <BaSeParagraph color="#000">
              Um salão de beleza possui um capital de giro próprio de R$ 10.000,00 - suficientes para o pagamento de parceiros, produtos
              e custos operacionais mensais em geral.
            </BaSeParagraph>
          </div>
        </div>
      </AccordionModal>}

      <FormBuilder
        initialValues={data}
        validationSchema={totalInvestmentValidation}
        onSubmit={handleSubmit}
      >
        <BaSeGrid>
          <BaSeGridItem desktop={{
            size: (postCredit || lab) ? 6 : 4,
            startAt: undefined,
          }}>
            <FormInput
              id="iif"
              name="iif"
              type="currency"
              isDisabled={isDisabled}
              label="Valor investimento fixo"
              onExternalChange={onChange}
              onExternalBlur={onChange}
              showHelpButton
              helpButtonProps={{
                direction: "bottom",
                alertSize: 180,
                iconProps: {
                  color: "#2E5DE6",
                  size: 16,
                },
                title: "Valor investimento fixo",
                message:
                  "Informe o valor dos móveis, equipamentos, máquinas e instalações. Para novos\n" +
                  "negócios, insira o valor do investimento necessário para iniciar as operações e alcançar as metas de vendas mensais.",
                type: "popover",
              }}
            />
          </BaSeGridItem>
          <BaSeGridItem desktop={{
            size: (postCredit || lab) ? 6 : 4,
            startAt: undefined,
          }}>
            <FormInput
              id="cgp"
              name="cgp"
              type="currency"
              isDisabled={isDisabled}
              label="Valor Capital de Giro próprio"
              onExternalChange={onChange}
              onExternalBlur={onChange}
              showHelpButton
              helpButtonProps={{
                direction: postCredit ? "right" : "bottom",
                alertSize: 200,
                iconProps: {
                  color: "#2E5DE6",
                  size: 16,
                },
                title: "Valor Capital de Giro próprio ",
                message:
                  "Informe o valor total disponível que a empresa possui para cobrir pagamentos e custos operacionais em momentos de baixa no caixa. Este é o investimento financeiro da empresa.",
                type: "popover",
              }}
              data-popover-target="cgp"
            />
          </BaSeGridItem>
        </BaSeGrid>
        {postCredit && (
          <div className="send-button">
            <Button type="submit" disabled={isDisabled}>
              Atualizar
            </Button>
          </div>
        )}
      </FormBuilder>
    </div>
  )
}

export default TotalInvestment
